<div class="container">
    <div class="row m-0">
        <div class="col pl-0">
            <div class="navigator">
                <a class="clickable" (click)="onClassesClicked()" translate>Classes</a>
                <span> > </span>
                <span *ngIf="model" translate
                    [translateParams]="{ name: model.name }">GroupClassDetails.Navigator</span>
            </div>
        </div>
        <div class="col pr-0 text-right">
            <div app-group-classes-details-settings [model]="model" [hasAttendens]="hasAttendance"></div>
        </div>
    </div>
</div>
<div class="container" *ngIf="model" [showIfPrivileges]="'GroupClasses.canViewClasses'" [clubIds]="model.club.id">
    <div class="row  m-0">
        <div class="col p-0">
            <div app-group-classes-details-basics [model]="model"></div>
        </div>
        <div class="col p-0" *ngIf="model.isBookingRequired">
            <app-group-classes-bookings [model]="model" (attendanceLoaded)="onAttendanceLoaded($event)"></app-group-classes-bookings>
        </div>
    </div>
</div>
